import { render, staticRenderFns } from "./PageHeadIcon.vue?vue&type=template&id=2adff5e8&scoped=true"
import script from "./PageHeadIcon.vue?vue&type=script&lang=ts"
export * from "./PageHeadIcon.vue?vue&type=script&lang=ts"
import style0 from "./PageHeadIcon.vue?vue&type=style&index=0&id=2adff5e8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adff5e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2adff5e8')) {
      api.createRecord('2adff5e8', component.options)
    } else {
      api.reload('2adff5e8', component.options)
    }
    module.hot.accept("./PageHeadIcon.vue?vue&type=template&id=2adff5e8&scoped=true", function () {
      api.rerender('2adff5e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/PageHeadIcon.vue"
export default component.exports